import Image from 'next/image';

export default function PracticeImage({ src, alt, compact = false }: { src: string; alt: string; compact?: boolean }) {
  return (
    <div className={`relative aspect-[8/5] w-full ${compact ? 'max-w-xs' : 'max-w-lg'}`}>
      <Image src={src} alt={alt} fill sizes={compact ? '(max-width: 640px) 80vw, 320px' : '(max-width: 640px) 90vw, 512px'} className="object-contain rounded-lg" />
    </div>
  );
}
